import { ResolvableModeEnum } from '@e-socna/data-layer';
import type { ResolverId } from '@e-socna/data-layer';

import type { EnrichedSection } from '../types/enriched-section.type';
import type { AnyResolverResult } from '../types/resolvers.type';

export const collectConditionResolverIds = (
  section: Readonly<EnrichedSection>,
): readonly ResolverId[] => [
  ...(section.displayCondition?.mode === ResolvableModeEnum.Dynamic &&
  section.displayCondition.resolverId
    ? [section.displayCondition.resolverId as ResolverId]
    : []),
  ...section.subSections.flatMap(collectConditionResolverIds),
];

// A condition not resolved yet keeps its section displayed: the condition
// resolvers depend on the same data as the content of the section.
export const isDisplayedBy = (
  displayCondition: EnrichedSection['displayCondition'],
  resolverResultOf: (resolverId: ResolverId) => AnyResolverResult | undefined,
): boolean => {
  if (!displayCondition) {
    return true;
  }

  if (displayCondition.mode === ResolvableModeEnum.Static) {
    return !!displayCondition.value;
  }

  const result = displayCondition.resolverId
    ? resolverResultOf(displayCondition.resolverId as ResolverId)
    : undefined;

  return result?.isSuccess ? result.data?.generated === true : true;
};
